import React from "react";
import SvgMapper from "../../features/common/SvgMapper";

const MicrophoneControl = ({ isEnabled, onToggle }) => {
  return (
    <button
      onClick={onToggle}
      className={`p-3 rounded-full text-white transition-colors relative ${
        isEnabled 
          ? "bg-green-600 hover:bg-green-700" 
          : "bg-red-500 hover:bg-red-600"
      }`}
      aria-label="toggle-mic"
    >
      <div className="relative">
        {SvgMapper.microphone("w-5 h-5")}
        {!isEnabled && (
          <div className="absolute inset-0 flex items-center justify-center">
            <svg
              className="w-5 h-5"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
            >
              <line x1="4" y1="4" x2="20" y2="20" />
            </svg>
          </div>
        )}
      </div>
    </button>
  );
};

export default MicrophoneControl;

